import get from 'lodash/get';
import { siteId, siteIds } from '@/utils';
import { defaultState } from '@/dashboard/store/state';

// Only fetch once an hour, same as campaigns
let fetchCompleted = 0;
const needsFetch = () => {
	const timePassed = new Date().getTime() - fetchCompleted;
	const HOUR = 60 * 60 * 1000;

	return timePassed > HOUR;
};
const decodeHtml = (html) => {
	// https://stackoverflow.com/questions/7394748/whats-the-right-way-to-decode-a-string-that-has-special-html-entities-in-it?lq=1
	const text = document.createElement('textarea');
	text.innerHTML = html;
	return text.value;
};
const formatAnnouncement = (announcement) => {
	return {
		...announcement,
		date: announcement.date.split('T')[0],
		title: decodeHtml(announcement.title.rendered).replace('[Announcement] ', ''),
		excerpt: decodeHtml(announcement.excerpt.rendered)
			// We want to remove the paragraph tag at the beginning for more consistent styling
			.replace('<p>', '')
			// We want to trim off the link section at the end since we are adding buttons
			.split('<a')[0]
			// There is already an ellipse object ('…') on each but sometimes there is a duplicate so let's remove that
			.replace('...', ''),
	};
};
export default {
	fetch({ commit, dispatch, rootGetters }, payload = {}) {
		return new Promise((resolve, reject) => {
			// Run only if it has been over 2 hours, it is not yet connected, or
			// we are passing in a filter and need to update the data
			if ((!needsFetch() || !rootGetters.connected) && !payload.filter) {
				return resolve();
			}

			let params = [];
			let query = '';
			let promise1 = Promise.resolve();

			commit('loading', 'accountDash', { root: true });

			params.push(`site=${siteIds ? siteIds.join(',') : siteId}`);

			if (payload.filter) {
				params.push(`filter=${payload.filter}`);

				if (payload.start) {
					params.push(`start=${this._vm.$moment(payload.start).format('YYYY-MM-DD')}`);
				}

				if (payload.end) {
					params.push(`end=${this._vm.$moment(payload.end).format('YYYY-MM-DD')}`);
				}
			} else {
				params.push('filter=30-days');
				params.push(`start=${this._vm.$moment().subtract(29, 'days').format('YYYY-MM-DD')}`);
				params.push(`end=${this._vm.$moment().format('YYYY-MM-DD')}`);
			}
			if (params.length) {
				query = `?${params.join('&')}`;
			}

			if (rootGetters.shouldFetchUser) {
				promise1 = dispatch('fetchMe', {}, { root: true }).catch((error) => {
					// eslint-disable-next-line no-console
					console.error({ error });
					return reject(error);
				});
			}

			const promise2 = new Promise(() => {
				this._vm.$api.get(`account-dashboard${query}`).then(({ body }) => {
					commit('doneLoading', 'accountDash', { root: true });

					const stats = get(body, 'widgets.analytics.range1', defaultState()['analytics']);
					commit('setAnalyticsData', stats);

					const topCampaigns = get(body, 'widgets.top-campaigns', defaultState()['topCampaigns'])
						.slice(0, 5)
						.map((campaign) => {
							return dispatch('campaigns/fetchWpCampaign', campaign.campaign_id, { root: true })
								.then((wpCampaign) => {
									campaign.enabled = !!parseInt(wpCampaign.post_meta._omapi_enabled);
									return campaign;
								})
								.catch(() => {
									campaign.enabled = false;
									return campaign;
								});
						});

					Promise.all(topCampaigns).then((campaigns) => {
						commit('setTopCampaigns', campaigns);
					});

					if (body.minDate) {
						commit('setMinDate', body.minDate);
					}
				});
			});

			Promise.all([promise1, promise2])
				.then(() => {
					resolve();
				})
				.catch((error) => {
					reject(error);
					// eslint-disable-next-line no-console
					console.error(error);
				});
		});
	},
	fetchAnnouncements({ commit }) {
		return new Promise((resolve, reject) => {
			commit('loading', 'announcements', { root: true });
			this._vm.$http
				.get(this._vm.$urls.marketing('wp-json/wp/v2/posts?categories=7&per_page=2&context=embed'))
				.then(({ body }) => {
					commit('doneLoading', 'announcements', { root: true });
					const announcements = (body ? body : defaultState()['announcements']).map((announcement) =>
						formatAnnouncement(announcement)
					);
					commit('setAnnouncements', announcements);
				})
				.then(() => {
					resolve();
				})
				.catch((error) => {
					reject(error);
					// eslint-disable-next-line no-console
					console.error({ error });
				});
		});
	},
};
